// libs
import { ThemeProvider } from "styled-components";
import { Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
// styles
import { GlobalStyle } from "./styles/global-styles";
import { theme } from "./styles/theme";
// routes
import Home from "./routes/Home";
import { ArtifactThemePage } from "./routes/ArtifactTheme";
import { About } from "./routes/About";
import { CinemaRoom } from "./routes/CinemaRoom";
import { Timeline } from "./routes/Timeline";
import Search from "./routes/Search";
import { Sitemap } from "./routes/Sitemap";
import { AbsoluteRedirect } from "./routes/AbsoluteRedirect";
// context
import { MenuOpenProvider } from "./context/MenuOpenContext";
import { ShowIntroProvider } from "./context/IntroContext";
import { LogoStyleProvider } from "./context/LogoStyleContext";
import { ArtifactsProvider } from "./context/ArtifactsContext";

function App() {
  const location = useLocation();

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <MenuOpenProvider>
        <ShowIntroProvider>
          <LogoStyleProvider>
            <ArtifactsProvider>
              <AnimatePresence exitBeforeEnter>
                <Routes key={location.key} location={location}>
                  <Route path="/" element={<Home />} />
                  <Route path="about" element={<About />} />
                  <Route path="cinema" element={<CinemaRoom />} />
                  <Route path="pharmacy-in-time" element={<Timeline />} />
                  <Route path="search" element={<Search />} />
                  <Route path="sitemap" element={<Sitemap />} />
                  <Route path="themes">
                    <Route path=":themeId" element={<ArtifactThemePage />} />
                  </Route>
                  <Route path="privacy" element={<AbsoluteRedirect url = "https://www.boots-uk.com/privacy-notice/" />} />
                  <Route path="boots" element={<AbsoluteRedirect url = "https://www.boots-uk.com" />} />
                </Routes>
              </AnimatePresence>
            </ArtifactsProvider>
          </LogoStyleProvider>
        </ShowIntroProvider>
      </MenuOpenProvider>
    </ThemeProvider>
  );
}

export default App;
